import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledToolbox = styled.div`
	& img {
		opacity: 0.7;
	}
	& span {
		margin-left: 15px;
	}
`;

const Toolbox = (props) => {
	return (
		<StyledToolbox className='mb-2'>
			<span
				onClick={() => {
					props.setOpen(!props.open);
				}}
			>
				{!props.open && <img width='20px' src='/img/toolbox_closed.png' />}
				{props.open && <img width='20px' src='/img/toolbox_open.png' />}
			</span>
			{props.open && (
				<>
					<span>[...]</span> <span>[Fall 1 von x]</span>
				</>
			)}
		</StyledToolbox>
	);
};

Toolbox.propTypes = {
	open: PropTypes.bool,
	setOpen: PropTypes.func,
};

export { Toolbox };
